import { hashToIndex } from '@/utils/stringUtils.js';

export function useProfile() {
  const getColorProfile = (userId: string) => {
    const primaryColors = ['navy', 'green', 'yellow', 'pink', 'purple'];
    const color = primaryColors[hashToIndex(userId, primaryColors.length)];
    return color;
  };

  const getInitials = (nickname: string) => {
    return nickname ? nickname.charAt(0).toUpperCase() : '';
  };

  return {
    getColorProfile,
    getInitials,
  };
}
